/**
 * Interior materials sold as equipment. They are shown next to the highlighted / premium
 * features; other materials (cloth, velour, other) are not.
 */
export const PREMIUM_INTERIOR_MATERIALS = [
  'INTERIORMATERIAL_FULL_LEATHER',
  'INTERIORMATERIAL_PART_LEATHER',
  'INTERIORMATERIAL_ALCANTARA',
];

export const isPremiumInteriorMaterial = (key: string | null | undefined) =>
  PREMIUM_INTERIOR_MATERIALS.includes(key ?? '');
